import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import AddPatient from './AddPatient';

import 'bootstrap/dist/css/bootstrap.min.css';

interface AddPatientModalProps {
  toChild?: boolean;
  sendToParent: (open: boolean) => void;
}

function AddPatientModal(props: AddPatientModalProps) {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShow(false);
    props.sendToParent(false);
  };

  return (
    <>
      <Modal
        id="addPatientModal"
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add new patient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddPatient toggle={handleClose} />
        </Modal.Body>
        <Modal.Footer>
          <Button id="cancelAdd" variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddPatientModal;
